export default __webpack_public_path__ + "static/media/SASS.7830dd7b.jpg";